import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class GenericRequest {
  constructor(init) {
    if (isNil(init)) return undefined
    this._cardholder_id = init.cardholder_id
    this._date_of_birth = init.date_of_birth
    this._employee_id = init.employee_id
    this._gender = init.gender
    this._is_pharmacy_member = init.is_pharmacy_member
    this._member_name = init.member_name
    this._organization_name = init.organization_name
    this._person_code = init.person_code
    this._request_details = init.request_details
    this._social_security = init.social_security
    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._users_job_title = init.users_job_title
  }

  static shape = {
    cardholder_id: PropTypes.string,
    date_of_birth: PropTypes.string,
    employee_id: PropTypes.string,
    gender: PropTypes.string,
    is_pharmacy_member: PropTypes.bool,
    member_name: PropTypes.string,
    organization_name: PropTypes.string,
    person_code: PropTypes.string,
    request_details: PropTypes.string,
    social_security: PropTypes.string,
    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    users_job_title: PropTypes.string
  }

  get cardholder_id() {
    return this._cardholder_id
  }
  get date_of_birth() {
    return this._date_of_birth
  }
  get employee_id() {
    return this._employee_id
  }
  get gender() {
    return this._gender
  }
  get is_pharmacy_member() {
    return this._is_pharmacy_member
  }
  get member_name() {
    return this._member_name
  }
  get organization_name() {
    return this._organization_name
  }
  get person_code() {
    return this._person_code
  }
  get request_details() {
    return this._request_details
  }
  get social_security() {
    return this._social_security
  }
  get user_email() {
    return this._user_email
  }
  get user_name() {
    return this._user_name
  }
  get user_phone_number() {
    return this._user_phone_number
  }
  get users_job_title() {
    return this._users_job_title
  }
}

export default GenericRequest
